<div class="app-container flex items-center gap-2">
    <a href="javascript:;" routerLink="/home" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="logo outline-none">
        <img class="bg outline-none" width="100" height="50" priority placeholder ngSrc="/assets/logo-main.png" alt="IN2 logo" i18n-alt="@@navbarLogoAlt" />
        <img class="transparent outline-none" width="100" height="50" priority placeholder ngSrc="/assets/logo-white.png" alt="IN2 logo" i18n-alt="@@navbarLogoTransparentAlt" />
    </a>
    <nav class="hidden lg:flex gap-4">
        <ng-container *ngTemplateOutlet="navLinks"></ng-container>
    </nav>

    <span style="flex: 1 1 auto"></span>
    <a href="javascript:;" (click)="contactUsDialog.openContactUsDialog()" class="button primary" i18n="@@navbarContactUs">Contact Us</a>

    <button
        (click)="toggleMenuDialog()"
        class="lg:hidden flex nav-link items-center justify-center text-inherit hover:text-primary"
        i18n-aria-label="@@navbarMenuButton"
        aria-label="Menu"
    >
        <span class="material-symbols-outlined">menu</span>
    </button>
</div>

<dialog #menuDialog class="inset-0">
    <div class="content flex flex-col justify-center items-start h-full p-8">
        <a href="javascript:;" routerLink="/home" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="logo mb-8 outline-none">
            <img width="100" height="50" priority placeholder ngSrc="/assets/logo-main.png" alt="IN2 logo" i18n-alt="@@navbarMobileLogoAlt" />
        </a>

        <a href="javascript:;" routerLink="/home" [routerLinkActive]="'active'" class="nav-link" i18n="@@navbarMobileLinkHome">Home</a>

        <a
            href="javascript:;"
            routerLink="/case-studies"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
            i18n="@@navbarMobileLinkCaseStudies"
            >Case Studies</a
        >

        <a href="javascript:;" routerLink="/blog" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" i18n="@@navbarMobileLinkBlog">Blog</a>

        <div menu class="relative group">
            <a class="nav-link" i18n="@@navbarMobileAboutUs">About us</a>
            <ul>
                <li class="ms-4">
                    <a routerLink="/our-mission" class="nav-link" i18n="@@navbarMobileOurMission"> - Our Mission</a>
                </li>
                <li class="ms-4">
                    <a routerLink="/who-we-are" class="nav-link" i18n="@@navbarMobileWhoWeAre"> - Who We Are</a>
                </li>
                <li class="ms-4">
                    <a routerLink="/about-us" class="nav-link" i18n="@@navbarMobileAboutCompany"> - About The Company</a>
                </li>
            </ul>
        </div>
        <span class="flex-auto"></span>
        <in2-language-selector class="self-end"></in2-language-selector>

        <button (click)="closeMenuDialog($event)" id="closeMobileMenu" class="text-gray-600 hover:text-gray-800" i18n-aria-label="@@navbarCloseMenu" aria-label="Close menu">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>
    </div>
</dialog>

<ng-template #navLinks>
    <a href="javascript:;" routerLink="/home" [routerLinkActive]="'active'" class="nav-link" i18n="@@navbarLinkHome">Home</a>

    <a href="javascript:;" routerLink="/case-studies" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" i18n="@@navbarLinkCaseStudies"
        >Case Studies</a
    >

    <a href="javascript:;" routerLink="/blog" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }" class="nav-link" i18n="@@navbarLinkBlog">Blog</a>

    <div menu class="relative group">
        <button trigger="menuItems" class="nav-link" i18n-aria-label="@@navbarDropdownMenuButton" aria-label="Open dropdown menu">
            <span i18n="@@navbarAboutUs">About us</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 7.5L10 12.5L15 7.5" stroke="#475467" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
        <div id="menuItems" class="absolute hidden bg-[#fcfcfc] shadow-lg py-2 mt-2 z-10">
            <a routerLink="/our-mission" class="block text-nowrap px-4 py-2 text-gray-700 hover:bg-gray-100" i18n="@@navbarMobileOurMission">Our Mission</a>
            <a routerLink="/who-we-are" class="block text-nowrap px-4 py-2 text-gray-700 hover:bg-gray-100" i18n="@@navbarMobileWhoWeAre">Who We Are</a>
            <a routerLink="/about-us" class="block text-nowrap px-4 py-2 text-gray-700 hover:bg-gray-100" i18n="@@navbarMobileAboutCompany">About The Company</a>
        </div>
    </div>
</ng-template>
